import { NodeUtils } from 'Editor/services/DataManager';
import { Command } from '../Command';
import { JsonRange } from 'Editor/services/_Common/Selection';

export class RestartListNumberingCommand extends Command {
  constructor(context: Editor.Edition.Context) {
    super(context);
  }

  async handleExec(): Promise<void> {
    try {
      this.buildActionContext();

      if (
        !this.context.DataManager ||
        !this.context.DataManager.selection ||
        !this.context.contentManipulator ||
        !this.actionContext
      ) {
        throw new Error('Invalid Context');
      }

      const jsonRange = this.actionContext.range;

      if (JsonRange.isSelectionEditable(this.context.DataManager, jsonRange)) {
        const rangesData = JsonRange.splitRangeByTypes(
          this.context.DataManager,
          jsonRange,
          NodeUtils.BLOCK_TEXT_TYPES,
        );

        const lists = rangesData?.find((data) => {
          return (
            data.baseData.id && this.context.DataManager?.numbering?.isListElement(data.baseData.id)
          );
        });

        if (lists && lists.baseData.id) {
          await this.context.DataManager.numbering.restartListNumbering(lists.baseData.id);

          this.createPatch();
        }
      }
    } catch (error) {
      throw error;
    }
  }
}
